import _slicedToArray from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { values as _values } from "lodash";
import { mainCialCountries } from "../constants";

var Util =
/*#__PURE__*/
function () {
  function Util() {
    _classCallCheck(this, Util);
  }

  _createClass(Util, null, [{
    key: "getInitials",

    /**
     *
     * Splits the given name by whitespace and takes the the first two initials
     * @param name the name whose initials are returned
     * @returns {string} the initials of the given name
     */
    value: function getInitials(name) {
      if (!name) {
        return "";
      }

      return name.replace(/[^\w\s]/, " ").split(/\s+/).filter(function (name) {
        return !!name;
      }).map(function (name) {
        return name[0].toUpperCase();
      }).splice(0, 2).join("");
    }
    /**
     * Converts an array into an object whose keys are the array elements itself and the values are set to `true`,
     * mimicking a set.
     * Example: [1, 2, 'pero] => {1: true, 2: true, 'pero': true}
     * @param array the array to be converted to an object
     */

  }, {
    key: "arrayToObject",
    value: function arrayToObject(array) {
      return array.reduce(function (acc, cur) {
        acc[cur] = true;
        return acc;
      }, {});
    }
    /**
     * Returns the file size in human readable format given the file size in bytes, for example: 9874321 => "9.42 MB"
     * @param fileSizeInBytes the size of the file in bytes
     * @returns {string} a human readable file size
     */

  }, {
    key: "getFileSize",
    value: function getFileSize(fileSizeInBytes) {
      var i = -1;
      var byteUnits = [" kB", " MB", " GB", " TB"];

      do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
      } while (fileSizeInBytes > 1024);

      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    }
    /**
     * Returns a sort function that sorts the elements by their index in the given array. Elements that are not found
     * in the array are sorted as biggest.
     * @param array the array in which elements are found
     * @returns {function(*=, *=)} the sorting function
     */

  }, {
    key: "sortByArrayIndex",
    value: function sortByArrayIndex(array) {
      return function (a, b) {
        var indexA = array.indexOf(a);
        var indexB = array.indexOf(b);

        if (indexA === -1) {
          return 1;
        }

        if (indexB === -1) {
          return -1;
        }

        return indexA - indexB;
      };
    }
    /**
     * Returns a sort function that sorts elements as D&B ratings, having the ones with a higher financial strength
     * first and, then, by risk indicator.
     * @param financialStrengthOrder the order in which financial strength indicators are sorted
     * @param riskIndicatorsOrder the order in which risk indicators are sorted
     * @return {function(*=, *=)} the sorting function
     */

  }, {
    key: "sortDnbRating",
    value: function sortDnbRating(financialStrengthOrder, riskIndicatorsOrder) {
      return function (a, b) {
        if (!a) {
          return 1;
        }

        if (!b) {
          return -1;
        }

        var financialStrengthA = a.slice(0, -1);
        var riskIndicatorA = a.slice(-1);
        var financialStrengthB = b.slice(0, -1);
        var riskIndicatorB = b.slice(-1);
        var res = Util.sortByArrayIndex(financialStrengthOrder)(financialStrengthA, financialStrengthB);

        if (res !== 0) {
          return res;
        }

        return Util.sortByArrayIndex(riskIndicatorsOrder)(riskIndicatorA, riskIndicatorB);
      };
    }
    /**
     * Returns counts given in an object converted to an array of sorted percents, taking only maxElements and putting
     * the sum of the rest of them into a field called 'other'.
     * @param object the object mapping elements to their respective counts
     * @param maxElements the maximum number of elements to output
     * @param sortFunction the function used to sort records
     * @returns {Array} an array of elements and their percentages
     */

  }, {
    key: "countToPercent",
    value: function countToPercent(object, maxElements) {
      var sortFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
        return object[b] - object[a];
      };

      if (!object) {
        return [];
      }

      var sum = _values(object).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);

      var sortedKeys = Object.keys(object).sort(sortFunction);
      var percents = [];
      var percentageSum = 0.0;

      for (var i = 0; i < sortedKeys.length; i++) {
        if (maxElements && i >= maxElements) {
          if (Math.abs(percentageSum - 100) > 1e-6) {
            percents.push(["other", 100.0 - percentageSum]);
          }

          break;
        }

        var key = sortedKeys[i];
        var value = object[key] / sum * 100.0;
        percentageSum += value;
        percents.push([key, value]);
      }

      return percents;
    }
    /**
     * Creates a string to be used as a URL query string from a query given as an object
     * @param query the query to turn into a URL query string
     * @returns {string} a URL query string
     */

  }, {
    key: "queryToString",
    value: function queryToString(query) {
      var keys = Object.keys(query);

      if (keys.length === 0) {
        return "";
      }

      return "?" + keys.map(function (key) {
        return key + "=" + query[key];
      }).join("&");
    }
    /**
     * Capitalizes each word in the given text
     * @param str the text to capitalize
     * @returns {string} the text with every word capitalized
     */

  }, {
    key: "capitalize",
    value: function capitalize() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return str.replace(/[^\s]+/g, function (word) {
        return word.replace(/^./, function (first) {
          return first.toUpperCase();
        });
      });
    }
    /**
     * Wraps a URL with http:// if it does not already start with a protocol
     * @param url the URL to wrap with http protocol
     * @return {string} the given URL wrapped with HTTP protocol, if not already existing
     */

  }, {
    key: "wrapWithHttp",
    value: function wrapWithHttp(url) {
      if (!/^https?:\/\//i.test(url)) {
        return "http://" + url;
      }

      return url;
    }
    /**
     * Returns the distance from the number x to its closest integer
     * @param x the number which distance is wanted
     * @return {number} the distance from the given number to its closest integer
     */

  }, {
    key: "distToInt",
    value: function distToInt(x) {
      return Math.abs(Math.round(x) - x);
    }
    /**
     * Given an array which values are numbers, rounds them so that their values round up to the target, adding or
     * removing first the values that are closest to a nearest integer.
     * @param arr an array of arrays which second element is the number that's actually evaluated
     * @param target the target sum to which to round to (defaults to 100)
     * @return {array} the array given as the first argument, with values adjusted so that they sum up to the target value
     */

  }, {
    key: "roundSum",
    value: function roundSum(arr) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
      var off = target - arr.map(function (x) {
        return x[1];
      }).reduce(function (acc, x) {
        return acc + Math.round(x);
      }, 0);
      var copy = arr.map(function (x, i) {
        return [x, i];
      });
      copy.sort(function (a, b) {
        return Util.distToInt(a[0][1]) - Util.distToInt(b[0][1]);
      }).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            x = _ref2[0],
            i = _ref2[1];

        return arr[i][1] = Math.round(x[1]) + (off > i) - (i >= arr.length + off);
      });
      return arr;
    }
    /**
     * Splits the given array into the wanted number of chunks. If the chunks cannot be of equal length, the first
     * chunks will receive more elements.
     *
     * Example:
     * const arr = [1,2,3,4,5,6,7,8,9];
     * splitToChunks(arr, 2)     // [[1,2,3,4,5],[6,7,8,9]]
     * splitToChunks(arr, 3)     // [[1,2,3],[4,5,6],[7,8,9]]
     * splitToChunks(arr, 4)     // [[1,2,3],[4,5],[6,7],[8,9]]
     *
     * @param array the array to divide into chunks (the original array is not altered)
     * @param chunks the number of chunks into which to divide array
     * @returns {*[]} a 2D array with elements from the original array and length matching the provided number of chunks
     */

    /**
     * A very light validator function for checking email validity. Rather then checking email against a
     * complex regex, it just checks whether the email is composed of: something@domain.com, with a minimum length
     * of 4 (meaning a@b.c is a valid email).
     *
     * @param email the string to check for email validity
     * @returns {*|boolean} whether the given string is a lightly-checked valid email
     */

    /**
     * Wrap existing promise into new structure that enables cancelation
     * of pending success handlers
     *
     * @param promise original promise which you want to handle with ".then" handlers(but be able to dismiss them)
     * @returns {{promise: Promise, cancel: function()}} - promise to use in the code, cancel function to skip
     * to reject flow
     */

    /**
     * Converting array to map
     * @param objectList - array of items we want to convert to object; key - by which attribute we want to index new object
     * @returns object which contains all array items in the form of object. Each item has a key-value pair where key is provided in params
     */

    /**
     * Empty callback
     * @param -
     * @returns undefined
     */

    /**
     * Clearing birForm postalCodeBrazil field value from underscore signs '_' and dash signs '-'
     * @param fieldValue - value from postalCodeBrazil field
     * @returns pure value without underscores and signs
     */

    /**
     * Counting decimal points
     * @param - String
     * @returns Number of decimal points
     */

    /**
     * Check COI range (value from 0-100)
     * @param - String
     * @returns Number of decimal points
     */

  }]);

  return Util;
}();

Util.splitToChunks = function (array, chunks) {
  if (chunks === 1) return [array];
  var size = Math.ceil(array.length / chunks);
  return [array.slice(0, size)].concat(Util.splitToChunks(array.slice(size), chunks - 1));
};

Util.isValidEmail = function (email) {
  return email && /\S+@\S+\.\S+/.test(email);
};

Util.makeCancelablePromise = function (promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};

Util.convertArrayToMap = function (objectList) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_id";
  var defaultValue = {};

  if (!objectList) {
    return defaultValue;
  }

  return objectList.reduce(function (result, object) {
    if (!object[key]) {
      return result;
    }

    result[object[key]] = object;
    return result;
  }, defaultValue);
};

Util.noop = function () {};

Util.createCialCountrySort = function (_ref3) {
  var valueProperty = _ref3.valueProperty,
      labelProperty = _ref3.labelProperty;
  return function (a, b) {
    var aIsMainCountry = mainCialCountries.includes(a[valueProperty]);
    var bIsMainCountry = mainCialCountries.includes(b[valueProperty]);

    if (!aIsMainCountry && !bIsMainCountry) {
      return a[labelProperty].localeCompare(b[labelProperty]);
    }

    if (aIsMainCountry && !bIsMainCountry) {
      return -1;
    }

    if (!aIsMainCountry && bIsMainCountry) {
      return 1;
    }

    return Util.sortByArrayIndex(mainCialCountries)(a[valueProperty], b[valueProperty]);
  };
};

Util.getPurePostalCodeBra = function (fieldValue) {
  return fieldValue.replace(/_|-/g, "");
};

Util.countDecimals = function (value) {
  if (!value || typeof value !== "string" || value.indexOf(".") === -1) {
    return;
  }

  if (value.match(/\,|\./g).length > 1) {
    return;
  }

  var regexCheck = /[0-9]+\.[0-9][0-9]/.exec(value);

  if (!regexCheck || regexCheck[0] !== regexCheck.input) {
    return;
  }

  return value.split(".")[1].length;
};

Util.checkCOIrange = function (value) {
  if (!value || typeof value !== "string" || value.indexOf(".") === -1) {
    return;
  }

  if (value.match(/\,|\./g).length > 1) {
    return;
  }

  var num = value.split(".")[0];
  return 0 <= num && num <= 100;
};

export default Util;